import { Text16pxBold } from "UI/shared/atoms/typographies/Text16pxBold";
import React from "react";

export const CommaSeparator: React.FC = () => (
  <Text16pxBold>,&#8239;</Text16pxBold>
);
